export type CalendarDayTone = "brand" | "danger" | "info" | "muted" | "success" | "warning";

export function calendarDayToneClass(tone: CalendarDayTone): string {
  const classes: Record<CalendarDayTone, string> = {
    brand: "bg-brand-soft-bg text-text-brand-strong ring-1 ring-brand-soft-border",
    danger: "bg-danger-bg text-danger-fg ring-1 ring-danger-fg/30",
    info: "bg-info-bg text-info-fg ring-1 ring-info-fg/30",
    muted: "bg-surface-muted text-text-secondary ring-1 ring-border",
    success: "bg-success-bg text-success-fg ring-1 ring-success-fg/30",
    warning: "bg-warning-bg text-warning-fg ring-1 ring-warning-fg/30",
  };
  return classes[tone];
}

export function buildCalendarMonthGrid(month: Date): Array<Date | null> {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const last = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  const offset = (first.getDay() + 6) % 7;
  const cells: Array<Date | null> = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= last.getDate(); d++) {
    cells.push(new Date(month.getFullYear(), month.getMonth(), d));
  }
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

export function calendarDateKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}
